import { useEffect, useRef } from 'react';
import { Box } from '@chakra-ui/react';
import AircallPhone from 'aircall-everywhere';

const CallInterface = () => {
  // Resources
  const aircallPhone = useRef(null);

  useEffect(() => {
    aircallPhone.current = new AircallPhone({
      domToLoadPhone: '#phone',
      size: 'auto',
    });
  }, []);

  return <Box w="100%" h="100vh" id="phone" />;
};

export default CallInterface;
